import { Operator } from "./model";
import { ColumnDef } from "@tanstack/react-table";

export const regionsColumns: ColumnDef<Operator>[] = [
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Email",
    accessorKey: "email",
  },
  {
    header: "Rating",
    accessorKey: "rating",
  },
  {
    header: "# yachts",
    accessorKey: "yachtCount",
  },
  {
    header: "visibility",
    accessorFn: (r) => {
      const v = r.visibility;
      const keys = [] as string[];
      if (v.helm_app_cya) {
        keys.push("CYA");
      }
      if (v.helm_app_bm_over_ns) {
        keys.push("BM/NSys");
      } else {
        if (v.helm_app_bm) {
          keys.push("BM");
        }
        if (v.helm_app_ns) {
          keys.push("NSys");
        }
      }
      if (v.helm_app_hide_skippered) {
        keys.push("s̶k̶i̶p̶p̶e̶r̶e̶d̶");
      }
      return keys.join(",");
    },
  },
  {
    header: "Notes",
    accessorKey: "notes",
  },
];
